module.exports = __webpack_public_path__ + "static/media/dark-logo.f1332c5b.png";